import { Component } from 'preact'

const alertHTML = (state) => {
  return <div
    role='alert'
    className={`alert alert-${state.type}`}
    style={!state.isVisible ? 'display: none' : ''} >
    {state.message}
  </div>
}

class AlertComponent extends Component {
  constructor (props) {
    super()
    this.state = {
      isVisible: false,
      message: '',
      type: '',
      isVisibleFor: props.isVisibleFor ? props.isVisibleFor : 3000
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.isVisible) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() =>
        this.setState({ isVisible: false })
      , this.state.isVisibleFor)
    }
  }

  success (message) {
    this.setState({
      isVisible: true,
      message: message || 'Changes applied successfully!',
      type: 'success'
    })
  }

  error (message) {
    this.setState({
      isVisible: true,
      message: message || 'Changes could not be applied',
      type: 'danger'
    })
  }

  render (props, state) {
    let Component = props.component
    return <Component
      {...props}
      successCallback={(e) => this.success(e)}
      errorCallback={(e) => this.error(e)}
      alertComponent={alertHTML(state)}
    />
  }
}

export default AlertComponent
